import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";

@Injectable()

export class LoginService {

    apiUrl: String;
    constructor(private http: Http) {
        this.apiUrl = environment.apiUrl;
    }

    sendPost(data){
        const url = this.apiUrl + "api/auth/admin/login";
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify(data);
        return this.http.post(url, body, {headers})
        .toPromise()
        .then(res => res.json())
        .then(resJson => resJson);
    }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/login/login.service.ts